import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ReferralEntry from "./pages/home/ReferralEntry";
import Welcome from "./pages/home/Welcome";
import Interview from "./pages/home/Interview";
import CaseHub from "./pages/home/CaseHub";
import ReportPage from "./pages/home/ReportPage";
import Login from "./pages/Login";
import OfficeLayout from "./pages/office/OfficeLayout";
import Dashboard from "./pages/office/Dashboard";
import Leads from "./pages/office/Leads";
import LeadDetail from "./pages/office/LeadDetail";
import Campaigns from "./pages/office/Campaigns";
import Partners from "./pages/office/Partners";
import Analytics from "./pages/office/Analytics";
import Compensation from "./pages/office/Compensation";
import PartnerDashboard from "./pages/office/PartnerDashboard";

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-center" />
      <Routes>
        <Route path="/" element={<Navigate to="/start" replace />} />
        <Route path="/r/:code" element={<ReferralEntry />} />
        <Route path="/start" element={<StartGate />} />
        <Route path="/review" element={<Interview />} />
        <Route path="/case" element={<CaseHub />} />
        <Route path="/case/report" element={<ReportPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/office" element={<OfficeLayout roles={["admin", "specialist"]} />}>
          <Route index element={<Dashboard />} />
          <Route path="leads" element={<Leads />} />
          <Route path="leads/:id" element={<LeadDetail />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="partners" element={<Partners />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="compensation" element={<Compensation />} />
        </Route>
        <Route path="/partner" element={<OfficeLayout roles={["partner"]} />}>
          <Route index element={<PartnerDashboard />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="analytics" element={<Analytics />} />
        </Route>
        <Route path="*" element={<Navigate to="/start" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

const StartGate = () => (new URLSearchParams(window.location.search).get("ref") ? <ReferralEntry /> : <Welcome />);

export default App;
